import type {CommitmentJobDisplay} from './commitment-job-display'
import {compactJobCode} from './radio-status'

export type TerminalIdentity = {
    title: string
    jobCode: string
    customer: string
    requirementSummary?: string
}

/** Human-first identity — title leads, code and customer support. */
export function terminalIdentity(display: CommitmentJobDisplay): TerminalIdentity {
    const code = compactJobCode(display.jobCode)
    let requirementSummary: string | undefined
    if (display.requirementCategorySummaryLine) {
        requirementSummary = display.requirementCategorySummaryLine
    } else if (display.shortageSummaryStrings.length > 0) {
        requirementSummary = display.shortageSummaryStrings
            .map((entry) => entry.replace(/^Missing /, ''))
            .join(' · ')
    } else if (display.assignedNames.length > 0) {
        requirementSummary = display.assignedNames.join(', ')
    }

    return {
        title: display.title,
        jobCode: code,
        customer: display.customer,
        requirementSummary,
    }
}
